import { Outlet } from 'react-router-dom';
import React, { useContext, useMemo } from 'react';
import NotFound from 'src/pages/httpStatuses/NotFound';
import { AuthContext } from 'src/AuthProvider';
import { checkRole } from 'src/common/helpers/checkRole';


export default function AllowRole({
	role,
}: { role: 'admin' | 'partner' | 'user' | 'super_admin' }) {
	const { user, } = useContext(AuthContext);

	const hasRole = useMemo<boolean | undefined>(() =>
		checkRole(role, { user, })
	, [ user, role, ]);

	return hasRole ? <Outlet /> : <NotFound />;
}
